import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  url = environment.url;
  constructor(public http: HttpClient) { }

  getDashboardData(stations, startDate, endDate) {
    let reqBody = {
      "startDate": startDate,
      "endDate": endDate,
      "stationId": stations
    }
    return this.http.post(`${this.url}` + '/dashboard/dashData', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }

  getDashboardGreets(stations) {
    let reqBody = {
      "date": moment().startOf('day').format("MM/DD/YYYY HH:mm"),
      "stationId": stations
    }
    return this.http.post(`${this.url}` + '/dashboard/greets', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }

  getCanceledGreets(stations) {
    let reqBody = {
      "stationId": stations
    }
    return this.http.post(`${this.url}` + '/dashboard/cancelled', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting canceled greets data'))),
    );
  }
  getStationWiseGreets(reqBody) {
    return this.http.post(`${this.url}` + '/dashboard/stationWiseGreetsStatus', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting canceled greets data'))),
    );
  }

  getTransactionsSummary(startDate, endDate) {
    let reqBody = {
      "fromDate": startDate,
      "toDate": endDate
    }
    return this.http.post(`${this.url}` + '/retailBooking/transactionsSummaryBySearch', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }
  getReservationsSummary(startDate, endDate) {
    let reqBody = {
      "fromDate": startDate,
      "toDate": endDate
    }
    return this.http.post(`${this.url}` + '/retailBooking/countReservationsTrans', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }

  getAllDueTransactions() {
    return this.http.get(`${this.url}` + '/retailBooking/dueUnPaidTransactions').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }


  getUnPaidTransactionsBySearch(startDate, endDate) {
    let reqBody = {
      "fromDate": startDate,
      "toDate": endDate
    }
    return this.http.post(`${this.url}` + '/retailBooking/unPaidTransactionsBySearch', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }

  getPendingPaymentTypeTransactions(startDate, endDate) {
    let reqBody = {
      "fromDate": startDate,
      "toDate": endDate
    }
    return this.http.post(`${this.url}` + '/retailBooking/pendingPaymentTypeTransactions', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }

  getAgedStatusReport() {
    return this.http.get(`${this.url}` + '/retailBooking/agedStatusReport').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }

  getTransactionReportBySearch(startDate, endDate, promoServices, stationCode, customerCompanyName, isCapitalone = []) {
    let reqBody = {
      "fromDate": startDate,
      "toDate": endDate,
      "promoservices": promoServices,
      "stationCode": stationCode,
      "customerCompanyName": customerCompanyName,
      "isCapitalOne": isCapitalone
    }
    return this.http.post(`${this.url}` + '/retailBooking/transactionReportBySearch', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting dashboard data'))),
    );
  }

}
